// removed by extract-text-webpack-plugin


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-notifications/dist/react-notifications.css
 ** module id = 1609
 ** module chunks = 0
 **/